export function popupImage() {
  const popup = document.getElementById('js-popup');
  // const blackBg = document.getElementById('js-black-bg');
  const closeBtn = document.getElementById('js-close-btn');
  const showBtn = document.getElementById('js-show-btn');
  const body = document.body;

  // toggleModal(blackBg);
  toggleModal(closeBtn);
  toggleModal(showBtn);

  // モーダルの開閉
  function toggleModal(e) {
    e.addEventListener('click', function click() {
      body.classList.toggle('is-hidden');
      popup.classList.toggle('is-show');
    });
  }
}
